/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_Col_AdjustedInputs */

const en_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjusted`)
};

const de_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angepasst`)
};

const fr_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusté`)
};

const es_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustado`)
};

const it_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adeguato`)
};

const nl_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepast`)
};

const pl_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skorygowane`)
};

const fi_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mukautettu`)
};

const da_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justeret`)
};

const sv_salary_compare_col_adjusted = /** @type {(inputs: Salary_Compare_Col_AdjustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justerad`)
};

/**
* | output |
* | --- |
* | "Adjusted" |
*
* @param {Salary_Compare_Col_AdjustedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_col_adjusted = /** @type {((inputs?: Salary_Compare_Col_AdjustedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_Col_AdjustedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_col_adjusted(inputs)
	if (locale === "fr") return fr_salary_compare_col_adjusted(inputs)
	if (locale === "es") return es_salary_compare_col_adjusted(inputs)
	if (locale === "it") return it_salary_compare_col_adjusted(inputs)
	if (locale === "nl") return nl_salary_compare_col_adjusted(inputs)
	if (locale === "pl") return pl_salary_compare_col_adjusted(inputs)
	if (locale === "fi") return fi_salary_compare_col_adjusted(inputs)
	if (locale === "da") return da_salary_compare_col_adjusted(inputs)
	if (locale === "sv") return sv_salary_compare_col_adjusted(inputs)
	return en_salary_compare_col_adjusted(inputs)
});